"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.complete.hero.title': 'Benvenuto su IntHub!',
    'register.complete.hero.description': 'Il tuo account è stato creato con successo. Controlla la tua email per attivare il tuo account.',
    'register.complete.title': 'Registrazione completata!',
    'register.complete.description': 'Grazie per esserti unito a IntHub. Abbiamo inviato un\'email di attivazione al tuo indirizzo.',
    'register.complete.email.check': 'Controlla la tua casella di posta e clicca sul link di attivazione per completare la registrazione.',
    'register.complete.login.button': 'Vai al login',
    'register.complete.home.button': 'Torna alla home',
    'register.complete.help.text': 'Hai bisogno di aiuto?',
    'register.complete.help.link': 'Contatta il supporto',
    'register.complete.email.sent': 'Email inviata a',
    'register.complete.button.login': 'Vai al Login',
    'register.complete.button.resend': 'Reinvia Email di Attivazione',
    'register.complete.help.check_spam': 'Controlla la cartella spam se non vedi l\'email nella tua casella di posta.',
    'register.complete.help.contact_support': 'Se hai bisogno di assistenza, contatta il nostro team di supporto.',
    'register.complete.resend.success': 'Email di attivazione reinviata con successo!',
};
